import styled from 'styled-components';

import ArrowDropDownIcon from '../../../../Icons/ArrowDropDownIcon';

export const CheckboxListWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  padding: ${props.isSingleFilter ? props.theme.spacing.small.s5 : props.theme.spacing.large.l15} ${
    props.theme.spacing.large.l15
  } ${props.isSingleFilter ? props.theme.spacing.large.l15 : props.theme.spacing.large.l25} ${
    props.theme.spacing.large.l15
  };
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lightd0};
`,
);

export const CheckBoxListHeaderDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const CheckBoxListRowDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: ${props => `${props.theme.spacing.large.l12}`};
`;

// export const TextLabel = styled.label`
//   cursor: pointer;
// `;

export const FlexColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const TextCenteredDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  cursor: default;
  justify-content: flex-start;
  width: ${props => (props.width ? props.width : 'auto')};
`;

export const ShowAllText = styled.div(
  props => `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  cursor: pointer;
  justify-content: flex-start;
  color: ${props.theme.colors.goBrand.blue};
`,
);

export const ResetTextWrapper = styled.span`
  font-size: ${props => props.theme.font.base};
  cursor: ${props => (props.isactive === 'true' ? 'pointer' : 'default')};
  color: ${props =>
    props.isactive === 'true' ? props.theme.colors.goBrand.blue : props.theme.colors.grey.grey50};
`;

export const StyledH5 = styled.h5(
  props => `
  font-size: ${props.theme.font.large.font14};
  color: ${props.theme.colors.black.base};
  font-weight:bold;
`,
);

export const CheckBoxListText = styled.span(
  props => `
    width:17.4rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: ${props.selected ? 'bold' : 'normal'};
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
`,
);
